<template>
  <div class="container-rtl">
    <button @click="$router.back()" class="btn btn-secondary mb-3">عودة</button>
    
    <div v-if="trainee">
      <!-- Organized Trainee Info Card -->
      <div class="trainee-info-card mb-4">
        <!-- Edit Mode -->
        <div v-if="editingTraineeInfo">
          <h2 class="trainee-name">تعديل بيانات المتدرب</h2>
          <form @submit.prevent="submitTraineeEdit">
            <div class="form-group">
              <label>الاسم:</label>
              <input type="text" v-model="traineeEditForm.name" required class="form-control" />
            </div>
            
            <div class="form-group">
              <label>العمر:</label>
              <input type="text" v-model="traineeEditForm.age" required class="form-control" />
            </div>
            
            <div class="form-group">
              <label>الطول:</label>
              <input type="text" v-model="traineeEditForm.height" class="form-control" />
            </div>
            
            <div class="form-group">
              <label>الوزن:</label>
              <input type="text" v-model="traineeEditForm.weight" class="form-control" />
            </div>
            
            <div class="form-group">
              <label>الجنس:</label>
              <input type="text" v-model="traineeEditForm.sex" class="form-control" />
            </div>
            
            <div class="form-group">
              <label>المدينة:</label>
              <input type="text" v-model="traineeEditForm.city" class="form-control" />
            </div>
            
            <div class="form-group">
              <label>العنوان:</label>
              <input type="text" v-model="traineeEditForm.address" class="form-control" />
            </div>
            
            <div class="form-group">
              <label>رقم الجوال:</label>
              <input type="text" v-model="traineeEditForm.phone" class="form-control" />
            </div>
            
            <div class="form-group">
              <label>الوظيفة:</label>
              <input type="text" v-model="traineeEditForm.job" class="form-control" />
            </div>
            
            <div class="form-group">
              <label>الحالة:</label>
              <input type="text" v-model="traineeEditForm.status" class="form-control" />
            </div>
            
            <div class="form-group">
              <label>مكان التمرين:</label>
              <input type="text" v-model="traineeEditForm.place" class="form-control" />
            </div>
            
            <div class="form-group">
              <label>الميزانية:</label>
              <input type="text" v-model="traineeEditForm.budget" class="form-control" />
            </div>
            
            <button type="submit" class="btn btn-success btn-sm mr-2">حفظ</button>
            <button type="button" class="btn btn-secondary btn-sm" @click="cancelTraineeEdit">إلغاء</button>
          </form>
        </div>
        
        <!-- View Mode -->
        <div v-else>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h2 class="trainee-name mb-0">{{ trainee.name }}</h2>
            <div>
              <button @click="startEditingTraineeInfo" class="btn btn-primary btn-sm ml-2">
                تعديل البيانات
              </button>
              <button @click="showCloneModal" class="btn btn-info btn-sm">
                نسخ المتدرب
              </button>
            </div>
          </div>
          
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">العمر:</span>
              <span class="info-value">{{ trainee.age }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">الطول:</span>
              <span class="info-value">{{ trainee.height }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">الوزن:</span>
              <span class="info-value">{{ trainee.weight }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">الجنس:</span>
              <span class="info-value">{{ trainee.sex }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">المدينة:</span>
              <span class="info-value">{{ trainee.city }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">العنوان:</span>
              <span class="info-value">{{ trainee.address }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">رقم الجوال:</span>
              <span class="info-value">{{ trainee.phone }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">الوظيفة:</span>
              <span class="info-value">{{ trainee.job }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">الحالة:</span>
              <span class="info-value">{{ trainee.status }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">مكان التمرين:</span>
              <span class="info-value">{{ trainee.place }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">الميزانية:</span>
              <span class="info-value">{{ trainee.budget }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Add New Training Button -->
      <div class="mb-4">
        <button 
          v-if="!addingNewExercise" 
          @click="startAddingExercise" 
          class="btn btn-success"
        >
          إضافة تمرين جديد
        </button>
      </div>

      <!-- Add New Exercise Form -->
      <div v-if="addingNewExercise" class="card mb-4">
        <div class="card-body">
          <h5 class="card-title">إضافة تمرين جديد</h5>
          <form @submit.prevent="submitNewExercise">
            <div class="form-group">
              <label>اختر مجموعة التمارين</label>
              <select v-model.number="newExerciseForm.groupId" class="form-control" required @change="onGroupChangeForNew">
                <option :value="null" disabled>اختر مجموعة</option>
                <option v-for="group in exerciseGroups" :key="group.id" :value="group.id">
                  {{ group.name }}
                </option>
              </select>
            </div>
            
            <div class="form-group" v-if="availableExercises.length > 0">
              <label>اختر التمرين</label>
              <v-select
                :options="availableExercises"
                label="name"
                :reduce="exercise => exercise.id"
                v-model="newExerciseForm.exercise_id"
                :clearable="false"
                placeholder="اختر التمرين"
              />
            </div>
            
            <div v-if="selectedNewExercise" class="mb-3">
              <img :src="trainingImageUrl(selectedNewExercise.image_name)" alt="صورة التمرين" style="height: 200px; width: auto; object-fit: cover;" />
            </div>
            
            <div class="form-group">
              <label>يوم التمرين</label>
              <select v-model.number="newExerciseForm.day" required class="form-control">
                <option v-for="d in 10" :key="d" :value="d">{{ d }}</option>
              </select>
            </div>
            
            <div class="form-group">
              <label>فترة الراحة</label>
              <input type="text" v-model="newExerciseForm.rest" required class="form-control" />
            </div>
            
            <div class="form-group">
              <label>عدد الجلسات</label>
              <input type="text" v-model="newExerciseForm.exercises_no" required class="form-control" />
            </div>
            
            <button type="submit" class="btn btn-success btn-sm mr-2">حفظ</button>
            <button type="button" class="btn btn-secondary btn-sm" @click="cancelAddExercise">إلغاء</button>
          </form>
        </div>
      </div>

      <!-- Exercises by Day -->
      <div v-if="Object.keys(exercisesByDay).length > 0" class="mt-4">
        <b-tabs card>
          <b-tab v-for="(exercises, day) in exercisesByDay" :key="day" :title="`اليوم ${day}`">
            <!-- Reorder Controls -->
            <div class="reorder-controls mb-3">
              <button 
                v-if="!reorderingDay || reorderingDay !== day"
                @click="startReordering(day)" 
                class="btn btn-info btn-sm"
              >
                إعادة الترتيب
              </button>
              <div v-else class="reorder-buttons">
                <button @click="saveOrder(day)" class="btn btn-success btn-sm mr-2">
                  حفظ الترتيب
                </button>
                <button @click="cancelReorder(day)" class="btn btn-secondary btn-sm">
                  إلغاء
                </button>
              </div>
            </div>

            <draggable 
              v-model="exercisesByDay[day]" 
              :disabled="reorderingDay !== day"
              class="list-group mt-2"
              handle=".drag-handle"
              @start="drag=true" 
              @end="drag=false"
            >
              <li v-for="(exercise, index) in exercisesByDay[day]" :key="`${day}-${index}`" class="list-group-item exercise-item">
                <div v-if="editingExercise && editingExercise.id === exercise.id" class="d-flex flex-column align-items-start">
                  <form @submit.prevent="submitEdit" class="w-100">
                    <div class="form-group">
                      <label>اختر مجموعة التمارين</label>
                      <select v-model.number="selectedGroupId" class="form-control" required>
                        <option :value="null" disabled>اختر مجموعة</option>
                        <option v-for="group in exerciseGroups" :key="group.id" :value="group.id">{{ group.name }}</option>
                      </select>
                    </div>
                    <div class="form-group" v-if="filteredExercises.length > 0">
                      <label>اختر التمرين الجديد</label>
                      <v-select
                        :options="filteredExercises"
                        label="name"
                        :reduce="exercise => exercise.id"
                        v-model="editForm.exercise_id"
                        :clearable="false"
                        placeholder="اختر التمرين الجديد"
                      />
                    </div>
                    <div v-if="selectedExercise" class="mb-3">
                      <img :src="trainingImageUrl(selectedExercise.image_name)" alt="صورة التمرين" style="height: 200px; width: auto; object-fit: cover;" />
                    </div>
                    <div class="form-group">
                      <label>يوم التمرين</label>
                      <select v-model.number="editForm.day" required class="form-control">
                        <option v-for="d in 10" :key="d" :value="d">{{ d }}</option>
                      </select>
                    </div>
                    
                    <div class="form-group">
                      <label>فترة الراحة</label>
                      <input type="text" v-model="editForm.rest" required class="form-control" />
                    </div>
                    
                    <div class="form-group">
                      <label>عدد الجلسات</label>
                      <input type="text" v-model="editForm.exercises_no" required class="form-control" />
                    </div>
                    
                    <button type="submit" class="btn btn-success btn-sm mr-2">حفظ</button>
                    <button type="button" class="btn btn-secondary btn-sm" @click="cancelEdit">إلغاء</button>
                  </form>
                </div>
                
                <!-- Organized Exercise Display -->
                <div v-else class="exercise-card">
                  <!-- Drag Handle -->
                  <div v-if="reorderingDay === day" class="drag-handle">
                    <span style="font-size: 24px; font-weight: bold;">⋮⋮</span>
                  </div>
                  
                  <div class="exercise-content">
                    <div class="exercise-image-container">
                      <img :src="trainingImageUrl(exercise.image_name)" class="exercise-image" alt="صورة التمرين" />
                    </div>
                    <div class="exercise-details">
                      <h5 class="exercise-name">{{ exercise.name }}</h5>
                      <div class="exercise-info-grid">
                        <div class="exercise-info-badge">
                          <span class="badge-label">الراحة:</span>
                          <span class="badge-value">{{ exercise.pivot.rest }}</span>
                        </div>
                        <div class="exercise-info-badge">
                          <span class="badge-label">الجلسات:</span>
                          <span class="badge-value">{{ exercise.pivot.exercises_no }}</span>
                        </div>
                        <div class="exercise-info-badge">
                          <span class="badge-label">اليوم:</span>
                          <span class="badge-value">{{ exercise.pivot.day_id }}</span>
                        </div>
                        <div class="exercise-info-badge">
                          <span class="badge-label">الترتيب:</span>
                          <span class="badge-value">{{ exercise.pivot.order_no }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="exercise-actions" v-if="reorderingDay !== day">
                    <button class="btn btn-primary btn-sm" @click="startEditing(exercise)">
                      تعديل
                    </button>
                    <button class="btn btn-danger btn-sm" @click="deleteExercise(exercise)">
                      حذف
                    </button>
                  </div>
                </div>
              </li>
            </draggable>
          </b-tab>
        </b-tabs>
      </div>
      <div v-else>
        <p>لا توجد تمارين لهذا المتدرب.</p>
      </div>
    </div>
    <div v-else>
      <p>جاري تحميل بيانات المتدرب...</p>
    </div>
    
    <!-- Clone Modal -->
    <b-modal v-model="showCloneDialog" title="نسخ المتدرب" hide-footer>
      <form @submit.prevent="submitClone">
        <div class="form-group">
          <label>اسم المتدرب الجديد:</label>
          <input 
            type="text" 
            v-model="newTraineeName" 
            required 
            class="form-control" 
            placeholder="أدخل اسم المتدرب الجديد"
          />
        </div>
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-secondary btn-sm mr-2" @click="showCloneDialog = false">
            إلغاء
          </button>
          <button type="submit" class="btn btn-success btn-sm">
            نسخ
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { BTabs, BTab, BModal } from 'bootstrap-vue'
import vSelect from 'vue-select'
import draggable from 'vuedraggable'
import 'vue-select/dist/vue-select.css'

export default {
  props: ['id'],
  components: {
    BTabs,
    BTab,
    BModal,
    'v-select': vSelect,
    draggable
  },
  data() {
    return {
      trainee: null,
      exercises: [],
      exercisesByDay: {},
      editingExercise: null,
      addingNewExercise: false,
      editingTraineeInfo: false,
      showCloneDialog: false,
      newTraineeName: '',
      selectedGroupId: null,
      exerciseGroups: [],
      filteredExercises: [],
      availableExercises: [],
      allExercises: [],
      reorderingDay: null,
      originalOrder: {},
      drag: false,
      editForm: {
        exercise_id: null,
        day: 1,
        order_no: 1,
        rest: '',
        exercises_no: ''
      },
      newExerciseForm: {
        groupId: null,
        exercise_id: null,
        day: 1,
        order_no: 1,
        rest: '',
        exercises_no: ''
      },
      traineeEditForm: {
        name: '',
        age: '',
        sex: '',
        city: '',
        address: '',
        phone: '',
        job: '',
        height: '',
        weight: '',
        status: '',
        place: '',
        budget: ''
      }
    }
  },
  computed: {
    selectedExercise() {
      if (!this.editForm.exercise_id) return null
      return this.filteredExercises.find(ex => ex.id === this.editForm.exercise_id) || null
    },
    selectedNewExercise() {
      if (!this.newExerciseForm.exercise_id) return null
      return this.availableExercises.find(ex => ex.id === this.newExerciseForm.exercise_id) || null
    }
  },
  watch: {
    selectedGroupId(newVal) {
      if (newVal) {
        this.loadExercisesByCategory(newVal)
        this.editForm.exercise_id = null
      } else {
        this.filteredExercises = []
        this.editForm.exercise_id = null
      }
    },
    exercises: {
      handler() {
        this.buildExercisesByDay()
      },
      deep: true
    }
  },
  async created() {
    this.loadExerciseGroups()
    this.loadAllExercises()
    this.loadTraineeData()
  },
  methods: {
    trainingImageUrl(imageUrl) {
      if (!imageUrl) return imageUrl

      try {
        const url = new URL(imageUrl)
        return `${this.$trainingBackendBaseURL}${url.pathname}${url.search}${url.hash}`
      } catch (error) {
        return imageUrl
      }
    },
    showCloneModal() {
      this.newTraineeName = ''
      this.showCloneDialog = true
    },
    async submitClone() {
      if (!this.newTraineeName.trim()) {
        this.$toast.error('الرجاء إدخال اسم المتدرب الجديد')
        return
      }
      
      try {
        const res = await this.$axios.post('/trainer/clone_trainee', {
          trainee_id: this.id,
          new_name: this.newTraineeName
        })
        
        if (res.data.success || res.data.code === 1) {
          this.$toast.success('تم نسخ المتدرب بنجاح')
          this.showCloneDialog = false
          this.newTraineeName = ''
          
          // Navigate to the new trainee
          if (res.data.trainee_id) {
            this.$router.push({ name: 'TraineeDetails', params: { id: res.data.trainee_id } })
          }
        } else {
          this.$toast.error('فشل نسخ المتدرب: ' + (res.data.message || 'خطأ غير معروف'))
        }
      } catch (error) {
        this.$toast.error('خطأ عند نسخ المتدرب')
        console.error(error)
      }
    },
    startEditingTraineeInfo() {
      this.editingTraineeInfo = true
      this.traineeEditForm = {
        name: this.trainee.name || '',
        age: this.trainee.age || '',
        sex: this.trainee.sex || '',
        city: this.trainee.city || '',
        address: this.trainee.address || '',
        phone: this.trainee.phone || '',
        job: this.trainee.job || '',
        height: this.trainee.height || '',
        weight: this.trainee.weight || '',
        status: this.trainee.status || '',
        place: this.trainee.place || '',
        budget: this.trainee.budget || ''
      }
    },
    cancelTraineeEdit() {
      this.editingTraineeInfo = false
      this.traineeEditForm = {
        name: '',
        age: '',
        sex: '',
        city: '',
        address: '',
        phone: '',
        job: '',
        height: '',
        weight: '',
        status: '',
        place: '',
        budget: ''
      }
    },
    async submitTraineeEdit() {
      try {
        const payload = {
          trainee_id: this.id,
          name: this.traineeEditForm.name,
          age: this.traineeEditForm.age,
          sex: this.traineeEditForm.sex,
          city: this.traineeEditForm.city,
          address: this.traineeEditForm.address,
          phone: this.traineeEditForm.phone,
          job: this.traineeEditForm.job,
          height: this.traineeEditForm.height,
          weight: this.traineeEditForm.weight,
          status: this.traineeEditForm.status,
          place: this.traineeEditForm.place,
          budget: this.traineeEditForm.budget
        }
        
        const res = await this.$axios.post('/trainer/update_trainee_info', payload)
        
        if (res.data.success || res.data.code === 1) {
          this.$toast.success('تم تحديث بيانات المتدرب بنجاح')
          
          // Update local trainee object
          this.trainee.name = this.traineeEditForm.name
          this.trainee.age = this.traineeEditForm.age
          this.trainee.sex = this.traineeEditForm.sex
          this.trainee.city = this.traineeEditForm.city
          this.trainee.address = this.traineeEditForm.address
          this.trainee.phone = this.traineeEditForm.phone
          this.trainee.job = this.traineeEditForm.job
          this.trainee.height = this.traineeEditForm.height
          this.trainee.weight = this.traineeEditForm.weight
          this.trainee.status = this.traineeEditForm.status
          this.trainee.place = this.traineeEditForm.place
          this.trainee.budget = this.traineeEditForm.budget
          
          this.cancelTraineeEdit()
        } else {
          this.$toast.error('فشل تحديث بيانات المتدرب: ' + (res.data.message || 'خطأ غير معروف'))
        }
      } catch (error) {
        this.$toast.error('خطأ عند تحديث بيانات المتدرب')
        console.error(error)
      }
    },
    buildExercisesByDay() {
      const groups = {}
      this.exercises.forEach(exer => {
        const day = (exer.pivot && exer.pivot.day_id) || '1'
        if (!groups[day]) groups[day] = []
        groups[day].push(exer)
      })
      Object.keys(groups).forEach(day => {
        groups[day].sort((a, b) => a.pivot.order_no - b.pivot.order_no)
      })
      this.exercisesByDay = groups
    },
    async loadExerciseGroups() {
      try {
        const res = await this.$axios.get('/trainer/categories')
        if (res.data.categories) {
          this.exerciseGroups = res.data.categories
        } else {
          this.exerciseGroups = []
        }
      } catch (error) {
        this.$toast.error('فشل جلب مجموعات التمارين')
        this.exerciseGroups = []
      }
    },
    async loadExercisesByCategory(cat_id) {
      try {
        const res = await this.$axios.get('/trainer/category_exercises', {
          params: { cat_id }
        })
        if (res.data.exercises) {
          this.filteredExercises = res.data.exercises
        } else {
          this.filteredExercises = []
        }
      } catch (error) {
        this.$toast.error('فشل جلب تمارين الفئة')
        this.filteredExercises = []
      }
    },
    async onGroupChangeForNew() {
      if (this.newExerciseForm.groupId) {
        try {
          const res = await this.$axios.get('/trainer/category_exercises', {
            params: { cat_id: this.newExerciseForm.groupId }
          })
          if (res.data.exercises) {
            this.availableExercises = res.data.exercises
          } else {
            this.availableExercises = []
          }
        } catch (error) {
          this.$toast.error('فشل جلب تمارين الفئة')
          this.availableExercises = []
        }
      }
      this.newExerciseForm.exercise_id = null
    },
    async loadAllExercises() {
      try {
        const res = await this.$axios.get('/trainer/excercises')
        if (res.data.trainees) {
          this.allExercises = res.data.trainees
        } else {
          this.allExercises = []
        }
      } catch (e) {
        this.$toast.error('فشل جلب قائمة التمارين')
        this.allExercises = []
      }
    },
    async loadTraineeData() {
      try {
        const resTrainee = await this.$axios.get('/trainer/trainee_data', {
          params: { trainee_id: this.id }
        })
        if (resTrainee.data.trainee) {
          this.trainee = resTrainee.data.trainee
          const resExercises = await this.$axios.get('/trainer/trainee_exercises', {
            params: { trainee_id: this.id }
          })
          if (resExercises.data && Array.isArray(resExercises.data.exercises)) {
            this.exercises = resExercises.data.exercises
            this.buildExercisesByDay()
          } else {
            this.exercises = []
            this.exercisesByDay = {}
            this.$toast.info('لا توجد تمارين لهذا المتدرب.')
          }
        } else {
          this.trainee = null
        }
      } catch (e) {
        this.$toast.error('خطأ في تحميل بيانات المتدرب')
        this.trainee = null
        this.exercises = []
      }
    },
    startAddingExercise() {
      this.addingNewExercise = true
      this.newExerciseForm = {
        groupId: null,
        exercise_id: null,
        day: 1,
        order_no: this.exercises.length + 1,
        rest: '',
        exercises_no: ''
      }
    },
    cancelAddExercise() {
      this.addingNewExercise = false
      this.availableExercises = []
      this.newExerciseForm = {
        groupId: null,
        exercise_id: null,
        day: 1,
        order_no: 1,
        rest: '',
        exercises_no: ''
      }
    },
    async submitNewExercise() {
      try {
        const payload = {
          trainee_id: this.id,
          exercise_id: this.newExerciseForm.exercise_id,
          day: this.newExerciseForm.day,
          order_no: this.newExerciseForm.order_no,
          rest: this.newExerciseForm.rest,
          exercises_number: this.newExerciseForm.exercises_no
        }
        
        const res = await this.$axios.post('/trainer/store_trainee_exercise', payload)
        
        if (res.data.success) {
          this.$toast.success('تم إضافة التمرين بنجاح')
          this.cancelAddExercise()
          
          await this.loadAllExercises()
          await this.loadTraineeData()
          
          this.filteredExercises = []
          this.selectedGroupId = null
        } else {
          this.$toast.error('فشل إضافة التمرين: ' + (res.data.message || 'خطأ غير معروف'))
        }
      } catch (error) {
        this.$toast.error('خطأ عند إضافة التمرين')
        console.error(error)
      }
    },
    async deleteExercise(exercise) {
      if (!confirm(`هل أنت متأكد من حذف التمرين "${exercise.name}"؟`)) {
        return;
      }
      
      try {
        const res = await this.$axios.post('/trainer/delete_exercise', {
          trainee_id: this.id,
          exercise_id: exercise.id
        });
        
        if (res.data.code === 1) {
          this.$toast.success('تم حذف التمرين بنجاح');
          await this.loadTraineeData();
        } else {
          this.$toast.error('فشل حذف التمرين: ' + (res.data.message || 'خطأ غير معروف'));
        }
      } catch (error) {
        this.$toast.error('خطأ عند حذف التمرين');
        console.error(error);
      }
    },
    startReordering(day) {
      this.reorderingDay = day
      this.originalOrder[day] = JSON.parse(JSON.stringify(this.exercisesByDay[day]))
    },
    cancelReorder(day) {
      if (this.originalOrder[day]) {
        this.$set(this.exercisesByDay, day, JSON.parse(JSON.stringify(this.originalOrder[day])))
      }
      this.reorderingDay = null
      delete this.originalOrder[day]
    },
    async saveOrder(day) {
      try {
        const exercisesToUpdate = this.exercisesByDay[day]
        
        for (let i = 0; i < exercisesToUpdate.length; i++) {
          const exercise = exercisesToUpdate[i]
          const newOrderNo = i + 1
          
          await this.$axios.post('/trainer/edit_trainee_exercises', {
            exercise_id: exercise.id,
            current_exercise_id: exercise.id,
            rest: exercise.pivot.rest,
            exercises_number: exercise.pivot.exercises_no,
            trainee_id: this.id,
            day: exercise.pivot.day_id,
            order_no: newOrderNo
          })
          
          exercise.pivot.order_no = newOrderNo
        }
        
        this.$toast.success('تم حفظ الترتيب الجديد بنجاح')
        this.reorderingDay = null
        delete this.originalOrder[day]
        await this.loadTraineeData()
      } catch (error) {
        this.$toast.error('خطأ عند حفظ الترتيب')
        console.error(error)
      }
    },
    async startEditing(exercise) {
      if (!this.exerciseGroups.length) {
        await this.loadExerciseGroups()
      }
      this.editingExercise = exercise
      this.selectedGroupId = exercise.category_id || null
      if (this.selectedGroupId) {
        await this.loadExercisesByCategory(this.selectedGroupId)
      }
      this.editForm.exercise_id = exercise.id
      this.editForm.day = Number(exercise.pivot.day_id) || 1
      this.editForm.order_no = Number(exercise.pivot.order_no) || 1
      this.editForm.rest = exercise.pivot.rest || ''
      this.editForm.exercises_no = exercise.pivot.exercises_no || ''
    },
    cancelEdit() {
      this.editingExercise = null
      this.selectedGroupId = null
      this.editForm = {
        exercise_id: null,
        day: 1,
        order_no: 1,
        rest: '',
        exercises_no: ''
      }
    },
    async submitEdit() {
      try {
        const payload = {
          exercise_id: this.editForm.exercise_id,
          current_exercise_id: this.editingExercise.id,
          rest: this.editForm.rest,
          exercises_number: this.editForm.exercises_no,
          trainee_id: this.id,
          day: this.editForm.day,
          order_no: this.editForm.order_no
        }
        const res = await this.$axios.post('/trainer/edit_trainee_exercises', payload)
        if (res.data.success) {
          const newExercise = this.filteredExercises.find(e => e.id === this.editForm.exercise_id)
            || this.allExercises.find(e => e.id === this.editForm.exercise_id)
          if (newExercise) {
            this.editingExercise.name = newExercise.name
            this.editingExercise.image_name = newExercise.image_name
            this.editingExercise.id = newExercise.id
          }
          this.editingExercise.pivot.rest = this.editForm.rest
          this.editingExercise.pivot.exercises_no = this.editForm.exercises_no
          this.editingExercise.pivot.day_id = this.editForm.day
          this.editingExercise.pivot.order_no = this.editForm.order_no
          const index = this.exercises.findIndex(e => e.id === res.data.current_exercise_id)
          if (index !== -1) {
            this.$set(this.exercises, index, { ...this.editingExercise })
          }
          this.cancelEdit()
          this.$toast.success('تم تعديل التمرين بنجاح')
        } else {
          this.$toast.error('فشل التعديل: ' + (res.data.message || 'خطأ غير معروف'))
        }
      } catch (error) {
        this.$toast.error('خطأ عند تعديل التمرين')
      }
    }
  }
}
</script>

<style scoped>
.container-rtl {
  width: 50vw;
  margin: 0 auto;
  direction: rtl;
  text-align: right;
}

/* Clone Modal RTL Styling */
::v-deep .modal-content {
  direction: rtl;
  text-align: right;
}

::v-deep .modal-header {
  direction: rtl;
}

::v-deep .modal-title {
  text-align: right;
  width: 100%;
}

::v-deep .modal-body {
  direction: rtl;
  text-align: right;
}

::v-deep .modal-body .form-group {
  text-align: right;
}

::v-deep .modal-body .form-group label {
  text-align: right;
  display: block;
  margin-bottom: 5px;
}

::v-deep .modal-body .form-control {
  text-align: right;
  direction: rtl;
}

::v-deep .modal-footer {
  direction: rtl;
  justify-content: flex-start;
}

.trainee-info-card {
  background: white;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.trainee-name {
  color: #2c3e50;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #007bff;
  font-size: 28px;
  font-weight: 600;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.info-item:hover {
  background: #e9ecef;
}

.info-label {
  font-weight: 600;
  color: #495057;
  margin-left: 8px;
  min-width: 100px;
}

.info-value {
  color: #212529;
  flex: 1;
}

.card {
  direction: rtl;
  text-align: right;
}

.form-group {
  margin-bottom: 15px;
}

.mr-2 {
  margin-left: 10px;
}

.ml-2 {
  margin-right: 10px;
}

/* Reorder Controls */
.reorder-controls {
  display: flex;
  justify-content: flex-start;
  padding: 10px 0;
}

.reorder-buttons {
  display: flex;
  gap: 10px;
}

/* Drag Handle */
.drag-handle {
  cursor: move;
  padding: 10px;
  margin-left: 10px;
  color: #6c757d;
  font-size: 20px;
  display: flex;
  align-items: center;
  user-select: none;
}

.drag-handle:hover {
  color: #007bff;
}

/* Exercise Card Styling */
.exercise-item {
  padding: 0 !important;
  border: none !important;
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.exercise-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: white;
  transition: all 0.3s ease;
}

.exercise-card:hover {
  background: #f8f9fa;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.exercise-content {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 20px;
}

.exercise-image-container {
  flex-shrink: 0;
}

.exercise-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid #e0e0e0;
}

.exercise-details {
  flex: 1;
}

.exercise-name {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
}

.exercise-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.exercise-info-badge {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.exercise-info-badge:hover {
  background: #e9ecef;
}

.badge-label {
  font-weight: 600;
  color: #495057;
  margin-left: 8px;
  min-width: 60px;
}

.badge-value {
  color: #212529;
  flex: 1;
  font-weight: 400;
}

.exercise-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-right: 15px;
}

.exercise-actions .btn {
  min-width: 100px;
  font-weight: 600;
}

@media (max-width: 768px) {
  .container-rtl {
    width: 90vw;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .exercise-card {
    flex-direction: column;
    gap: 15px;
  }
  
  .exercise-content {
    flex-direction: column;
    width: 100%;
  }
  
  .exercise-info-grid {
    grid-template-columns: 1fr;
  }
  
  .exercise-actions {
    flex-direction: row;
    width: 100%;
    margin-right: 0;
  }
  
  .exercise-actions .btn {
    flex: 1;
  }
}
</style>
